'use client';

import { createFileRoute } from '@tanstack/react-router';

import { SuppliersDashboardPage } from '@/features/suppliers';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/suppliers/')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.suppliersDashboard'),
  }),
  component: SuppliersDashboardRoute,
});

function SuppliersDashboardRoute() {
  return <SuppliersDashboardPage />;
}
